export default __webpack_public_path__ + "static/media/banescale.60e9ac8f.png";